var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h100vh-100",attrs:{"id":"trackTable"}},[_c('MonitTableMenu',{on:{"methodEnum":_vm.methodEnum}}),_c('MonitTable',{ref:"monitTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }